import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25b303f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "student" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("学员信息")
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "serach-box" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "学生姓名：", -1))
const _hoisted_7 = { class: "input" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "顾问姓名：", -1))
const _hoisted_10 = { class: "input" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "教务：", -1))
const _hoisted_13 = { class: "input" }
const _hoisted_14 = {
  class: "item",
  style: {"margin-right":"10px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "年份：", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" excel导入 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 复制模板 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_20 = { class: "table" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 身份证号: ")
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 报名时间: ")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 身份证号: ")
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 报名时间: ")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("已签署")
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("未签署")
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("已签署")
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("未签署")
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_44 = { class: "pagination" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 识别 ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" (可输入关键字) ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" (可输入关键字) ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 测试 ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 识别 ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" (可输入关键字) ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" (可输入关键字) ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 测试 ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Ctrl+A全部选中，Ctrl+C复制，Ctrl+V粘贴")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "up-bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"50px","height":"50px","margin-top":"20px"},
    src: "https://img2.baidu.com/it/u=410870683,732754755&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1672419600&t=5d8a34484659aa6473dd392ebd9a1b49",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "文档导入"),
  /*#__PURE__*/_createElementVNode("p", null, "将文档拖入此虚线区域内或者点击上传")
], -1))

import { onMounted, ref } from "vue";
import type { ElForm } from "element-plus";
import { ElMessage } from "element-plus";
import {
  getAcademies,
  getMajors,
  getStudentList,
  getXuejieList,
  regexStu,
  updateStudent,
  createStudent,
  deleteStudent,
  getEducationalList,
  Excel
} from "../config/interface";
type FormInstance = InstanceType<typeof ElForm>;
// #region 定义状态

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ruleFormRef = ref<FormInstance>();
const universityArr = require("../assets/university.json");
const popStatus = ref(false); // 弹出框状态
let dialogVisible = ref(false);
const dialogVisible2 = ref(false);
const dialogVisible3 = ref(false);
const tableLoading = ref(false);
const typeShow = ref(false);
const activeName = ref('1');
const activeName2 = ref('1');
let pageSize = ref(10); // 每页展示条数
let currentPage = ref(1); // 当前页数
let totalPage = ref(0);
let xuejieArr = ref([] as any);
let fuzerenArr = ref([] as any);
const temp = "学员姓名：\n电话：\n本科院校：\n本科专业：\n目标院校：\n目标专业：\n收费：\n是否拉群：\n调剂进度以及备注：\n日期：";
const temp2 = "学员姓名：\n目标院校：\n目标院系：\n目标专业：\n是否上岸：\n班型：\n课时：\n课程进度：\n研究生：\n研究生联系方式：\n收费：\n日期：";
// const temp = "学员姓名：\n电话：\n邮箱：\n身份证号：\n本科院校：\n本科专业：\n目标院校：\n目标院系：\n目标专业：\n顾问名称：\n报名时间：";
// 筛选条件
let search = ref({
  sName: "",
  gName: "",
  jName: "",
  year: '',
  yearChange: '',
});
let userInfo = ref({
  id: "",
  sName: "",
  phone: "",
  email: "",
  idCard: "",
  college: "",
  major: "",
  targetCollege: "",
  targetAcademy: "",
  targetMajor: "",
  gId: "",
  signTime: "",
  type: '', // 课程类别
  info: '', // 备注
  jId: '', // 顾问id
  charge: '', // 收费
  isGroup: '', // 是否拉群
  isSuccess: '', // 是否上岸
  studentAgreement: '', // 学员协议
  classType: '', // 班型
  classHour: '', // 课时
  postgraduate: '', // 研究生
  postgraduateContact: '', // 研究生联系方式
  postgraduateAgreement: '', // 研究生协议
  code: '', // 班号
});
let tableData = ref([]);
// 表单验证规则
const rules = {
  sName: [{ required: true, message: "请输入学生姓名", trigger: "blur" }],
  // phone: [
  //   { required: true, message: "请输入手机号码", trigger: "blur" },
  //   { min: 11, max: 11, message: "手机号码应为11位数", trigger: "blur" },
  // ],
  // type: [{ required: true, message: "请输入课程类别", trigger: "blur" }],
  // email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
  // idCard: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
  // college: [{ required: true, message: "请输入本科院校", trigger: "blur" }],
  // major: [{ required: true, message: "请输入本科专业", trigger: "blur" }],
  // targetCollege: [
  //   { required: true, message: "请选择目标院校", trigger: "blur" },
  // ],
  // targetAcademy: [
  //   { required: true, message: "请选择目标院系", trigger: "blur" },
  // ],
  // targetMajor: [{ required: true, message: "请选择目标专业", trigger: "blur" }],
  // gId: [{ required: true, message: "请选择顾问名称", trigger: "blur" }],
  // jId: [{ required: true, message: "请选择教务", trigger: "blur" }],
  // signTime: [{ required: true, message: "请选择报名时间", trigger: "blur" }],
};
let quickCont = ref(""); // 新建内容快速识别----应该由前端写方法，不应该请求接口
let btnLoading = ref(false); // 弹出框识别按钮loading状态
const editLoading = ref(false); // 弹出框的确定按钮loading状态
let targetCollegeCode = ref(""); // 目标院校CODE
let academyArr = ref([{}] as any); // 目标院系下拉列表
let targetAcademyCode = ref(""); // 目标院系名称
let majorArr = ref([{}] as any); // 目标专业下拉列表
let studentAgreementArr = ref([{ value: 1, label: '已签署' }, { value: 0, label: '未签署' }]); // 课程下拉列表
let postgraduateAgreementArr = ref([{ value: 1, label: '已签署' }, { value: 0, label: '未签署' }]); // 课程下拉列表
// #endregion
// #region 定义方法
// 测试
const handleTest = () => {
  console.log("test", userInfo.value);
};
const yearChange = (val: any) => {
  if (val) {
    let year = val.getFullYear()
    search.value.year = year
  } else {
    search.value.year = ''
  }
  getList(1, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
};
const tableRowClassName = ({ row }) => {
  if (row.orderStatus == 6) {
    return "success-row";
  } else if (row.orderStatus == 5) {
    return "warning-row";
  } else {
    return "";
  }
};
const handleClickType = (item: string) => {
  // console.log(parseInt(item), typeof parseInt(item));
  activeName.value = item
  let a = parseInt(item)
  getList(1, search.value.sName, search.value.gName, a, search.value.jName, search.value.year);
};
const handleClickType2 = (item: string) => {
  activeName2.value = item
  let work = JSON.parse(localStorage.getItem("ACCESS_TOKEN"));
  userInfo.value = {
    id: "",
    sName: "",
    phone: "",
    email: "",
    idCard: "",
    college: "",
    major: "",
    targetCollege: "",
    targetAcademy: "",
    targetMajor: "",
    gId: "",
    signTime: "",
    type: activeName2.value,
    jId: work.workId,
  } as any;
  quickCont.value = "";
};
const handleCopyTemp = () => {
  activeName2.value = '1';
  dialogVisible2.value = true;
  // const input = document.createElement("input");
  // document.body.appendChild(input);
  // let params = "学员姓名：\n电话：邮箱：身份证号：本科院校：本科专业：目标院校：目标院系：目标专业：顾问名称：报名时间：";
  // input.setAttribute("value", params);
  // input.select();
  // if (document.execCommand("copy")) {
  //   document.execCommand("copy");
  //   ElMessage.success("复制成功");
  // }
  // document.body.removeChild(input);
};
// Excel导入
const handleExcel = () => {
  dialogVisible3.value = true;
};
// Excel导入
const handleChange = (file: any) => {
  // 判断是不是.xlsx文件
  if (file.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    ElMessage.error('请上传.xlsx文件');
    return false;
  }
  let params = new FormData();
  params.append("file", file.file);
  Excel(params).then((res) => {
    if (res.data) {
      ElMessage.success(res.data.data);
      // 关闭弹窗
      dialogVisible3.value = false;
      getList(1, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
    } else {
      ElMessage.error(res.data.msg);
      dialogVisible3.value = false;
    }
  }).catch((error) => {
    ElMessage.error(error);
    dialogVisible3.value = false;
  });
};
// 删除学生信息
const handleDelete = (sId: number) => {
  deleteStudent({ sId }).then((res) => {
    if (res.data && res.data.errorCode === 200) {
      ElMessage.success(res.data.data);
      getList(1, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 选择目标院校
const handleSelectCollege = (val: string) => {
  universityArr.university.map((item: any) => {
    if (item.name === val) {
      targetCollegeCode.value = item.code;
    }
  });
  userInfo.value.targetAcademy = "";
  userInfo.value.targetMajor = "";
  getAcademies({ collegeCode: targetCollegeCode.value }).then((res) => {
    if (res.data.errorCode == 200) {
      if (res.data.data.length) {
        academyArr.value = res.data.data;
      } else {
        ElMessage.error("暂未查询到该学院的院系");
      }
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 选择目标院系
const handleSelectAcademy = (val: string) => {
  academyArr.value.map((item: any) => {
    if (item.academyName === val) {
      // console.log(item.academyCode);
      targetAcademyCode.value = item.academyCode;
    }
  });
  userInfo.value.targetMajor = "";
  getMajors({
    collegeCode: targetCollegeCode.value,
    academyCode: targetAcademyCode.value,
  }).then((res) => {
    if (res.data.errorCode == 200) {
      if (res.data.data.length) {
        majorArr.value = res.data.data;
      } else {
        ElMessage.error("暂未查询到该院系的专业");
      }
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 点击智能识别按钮，请求接口
const handleDistinguish = () => {
  btnLoading.value = true;
  regexStu({ matchContent: quickCont.value, type: activeName2.value }).then((res) => {
    userInfo.value = res.data.data;
    btnLoading.value = false;

    universityArr.university.map((item: any) => {
      if (res.data.data.targetCollege === item.name) {
        getAcademies({ collegeCode: item.code }).then((res2) => {
          if (res2.data.errorCode == 200) {
            if (res2.data.data.length) {
              academyArr.value = res2.data.data;
              res2.data.data.map((item2: any) => {
                if (res.data.data.targetAcademy === item2.academyName) {
                  getMajors({
                    collegeCode: item.code,
                    academyCode: item2.academyCode,
                  }).then((res3) => {
                    if (res3.data.errorCode == 200) {
                      if (res3.data.data.length) {
                        majorArr.value = res3.data.data;
                      } else {
                        ElMessage.error("暂未查询到该院系的专业");
                      }
                    } else {
                      ElMessage.error(res3.data.msg);
                    }
                  });
                }
              });
            } else {
              ElMessage.error("暂未查询到该学院的院系");
            }
          } else {
            ElMessage.error(res.data.msg);
            btnLoading.value = false;
          }
        });
      }
    });

    // xuejieArr.value.map((item:any)=>{
    // 	console.log(item);
    // 	if(userInfo.value.gId === item.id) {
    // 	}
    // })
  });
};
// 新增弹框的确认按钮，提交表单，请求接口
const handleInsert = (formEl: FormInstance | undefined) => {
  // console.log(userInfo.value);
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid && popStatus.value === true) {
      let params = {}
      if (activeName2.value == '1') {
        params = {
          sName: userInfo.value.sName,
          phone: userInfo.value.phone,
          college: userInfo.value.college,
          major: userInfo.value.major,
          targetCollege: userInfo.value.targetCollege,
          targetAcademy: userInfo.value.targetAcademy,
          targetMajor: userInfo.value.targetMajor,
          gId: userInfo.value.gId,
          jId: userInfo.value.jId,
          info: userInfo.value.info,
          charge: userInfo.value.charge,
          type: userInfo.value.type,
          isGroup: userInfo.value.isGroup,
          signTime: userInfo.value.signTime,
          code: userInfo.value.code,
        };
      } else {
        params = {
          sName: userInfo.value.sName,
          targetCollege: userInfo.value.targetCollege, // 目标学校
          targetAcademy: userInfo.value.targetAcademy, // 目标院系
          targetMajor: userInfo.value.targetMajor, // 目标专业
          isSuccess: userInfo.value.isSuccess, // 是否上岸
          studentAgreement: userInfo.value.studentAgreement, // 学生协议
          classType: userInfo.value.classType, // 班型
          classHour: userInfo.value.classHour, // 课时
          info: userInfo.value.info, // 课程进度
          postgraduate: userInfo.value.postgraduate, // 研究生
          postgraduateContact: userInfo.value.postgraduateContact, // 研究生联系方式
          postgraduateAgreement: userInfo.value.postgraduateAgreement, // 研究生协议
          charge: userInfo.value.charge, // 收费
          gId: userInfo.value.gId,
          jId: userInfo.value.jId,
          signTime: userInfo.value.signTime,
          type: userInfo.value.type,
          code: userInfo.value.code,
        };
      }
      editLoading.value = true;
      createStudent(params).then((res) => {
        if (res.data.data && res.data.success) {
          getList(1, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
          ElMessage.success(res.data.data);
          dialogVisible.value = false;
          editLoading.value = false;
        } else {
          ElMessage.error(res.data.msg);
          dialogVisible.value = false;
          editLoading.value = false;
        }
      });
    } else if (valid && popStatus.value === false) {
      let params = {};
      if (activeName.value == '1') {
        // 调剂
        params = {
          id: userInfo.value.id,
          sName: userInfo.value.sName,
          phone: userInfo.value.phone,
          college: userInfo.value.college,
          major: userInfo.value.major,
          targetCollege: userInfo.value.targetCollege,
          targetAcademy: userInfo.value.targetAcademy,
          targetMajor: userInfo.value.targetMajor,
          gId: userInfo.value.gId,
          jId: userInfo.value.jId,
          info: userInfo.value.info,
          charge: userInfo.value.charge,
          type: userInfo.value.type,
          isGroup: userInfo.value.isGroup,
          signTime: userInfo.value.signTime,
          code: userInfo.value.code,
        };
      } else {
        // 复试
        params = {
          id: userInfo.value.id,
          sName: userInfo.value.sName,
          targetCollege: userInfo.value.targetCollege, // 目标学校
          targetAcademy: userInfo.value.targetAcademy, // 目标院系
          targetMajor: userInfo.value.targetMajor, // 目标专业
          isSuccess: userInfo.value.isSuccess, // 是否上岸
          studentAgreement: userInfo.value.studentAgreement, // 学生协议
          classType: userInfo.value.classType, // 班型
          classHour: userInfo.value.classHour, // 课时
          info: userInfo.value.info, // 课程进度
          postgraduate: userInfo.value.postgraduate, // 研究生
          postgraduateContact: userInfo.value.postgraduateContact, // 研究生联系方式
          postgraduateAgreement: userInfo.value.postgraduateAgreement, // 研究生协议
          charge: userInfo.value.charge, // 收费
          gId: userInfo.value.gId,
          jId: userInfo.value.jId,
          signTime: userInfo.value.signTime,
          type: userInfo.value.type,
          code: userInfo.value.code,
        };
      }
      editLoading.value = true;
      updateStudent(params).then((res) => {
        if (res.data.data && res.data.success) {
          getList(1, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
          ElMessage.success(res.data.data);
          dialogVisible.value = false;
          editLoading.value = false;
        } else {
          ElMessage.error(res.data.data);
          dialogVisible.value = false;
          editLoading.value = false;
        }
      });
    } else {
      // console.log("error submit!");
      return false;
    }
  });
};
// 点击新建按钮，清口数据，弹出信息框
const handleCreate = () => {
  typeShow.value = true;
  activeName2.value = '1';
  let work = JSON.parse(localStorage.getItem("ACCESS_TOKEN"));
  popStatus.value = true;
  userInfo.value = {
    id: "",
    sName: "",
    phone: "",
    email: "",
    idCard: "",
    college: "",
    major: "",
    targetCollege: "",
    targetAcademy: "",
    targetMajor: "",
    gId: "",
    signTime: "",
    type: '1',
    jId: work.workId,
    code: ''
  } as any;
  quickCont.value = "";
  targetCollegeCode.value = "";
  targetAcademyCode.value = "";
  academyArr.value = [];
  majorArr.value = [];
  dialogVisible.value = true;
};
// 点击修改按钮，显示弹出框
const handleShowEdit = (val: any) => {
  activeName2.value = activeName.value;
  typeShow.value = false;
  let temp = JSON.parse(JSON.stringify(val));
  userInfo.value = temp;
  // userInfo.value = val
  popStatus.value = false;
  dialogVisible.value = true;
  academyArr.value = [];
  majorArr.value = [];
  universityArr.university.map((item: any) => {
    if (item.name === temp.targetCollege) {
      targetCollegeCode.value = item.code;
      getAcademies({ collegeCode: item.code }).then((res) => {
        if (res.data.errorCode == 200) {
          if (res.data.data.length) {
            academyArr.value = res.data.data;
            academyArr.value.map((item2: any) => {
              if (item2.academyName === temp.targetAcademy) {
                targetAcademyCode.value = item2.academyCode;
                getMajors({
                  collegeCode: item.code,
                  academyCode: item2.academyCode,
                }).then((res) => {
                  if (res.data.errorCode == 200) {
                    if (res.data.data.length) {
                      majorArr.value = res.data.data;
                    } else {
                      ElMessage.error("暂未查询到该院系的专业");
                    }
                  } else {
                    ElMessage.error(res.data.msg);
                  }
                });
              }
            });
          } else {
            ElMessage.error("暂未查询到该学院的院系");
          }
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    }
  });
};
// 点击搜索按钮，请求接口
const handleSearch = () => {
  getList(1, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
};
// 改变每页数量,请求列表数据接口
const handleSizeChange = (val: number) => {
  pageSize.value = val;
};
// 点击分页按钮,请求列表数据接口
const handleCurrentChange = (val: number) => {
  currentPage.value = val;
  getList(val, search.value.sName, search.value.gName, parseInt(activeName.value), search.value.jName, search.value.year);
};
const getList = (pageNum: number, sName: string, gName: string, type: number, jName: string, year: number) => {
  tableLoading.value = true;
  let params = { pageNum, sName, gName, type, jName, year };
  getStudentList(params).then((res) => {
    if (res.data && res.data.success) {
      tableData.value = res.data.data.list;
      totalPage.value = res.data.data.total;
      tableLoading.value = false;
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// #endregion

onMounted(() => {
  getList(1, search.value.sName, search.value.gName, 1, search.value.jName, search.value.year);
  getXuejieList({ nickName: "" }).then((res) => {
    xuejieArr.value = res.data.data;
  });
  getEducationalList({}).then((res) => {
    fuzerenArr.value = res.data.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, { type: "success" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_input, {
              modelValue: _unref(search).sName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).sName) = $event)),
              placeholder: "请输入学生姓名",
              clearable: "",
              onKeyup: _withKeys(handleSearch, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: _unref(search).gName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(search).gName) = $event)),
              placeholder: "请输入顾问姓名",
              clearable: "",
              onKeyup: _withKeys(handleSearch, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_input, {
              modelValue: _unref(search).jName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(search).jName) = $event)),
              placeholder: "请输入教务",
              clearable: "",
              onKeyup: _withKeys(handleSearch, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_el_date_picker, {
            modelValue: _unref(search).yearChange,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(search).yearChange) = $event)),
            type: "year",
            placeholder: "选择年",
            onChange: yearChange
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSearch
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: handleExcel
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: handleCopyTemp
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: handleCreate
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeName).value = $event)),
      type: "card",
      onTabClick: _cache[5] || (_cache[5] = ($event: any) => (handleClickType(activeName.value)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "调剂",
          name: "1"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "复试",
          name: "2"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_20, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        "row-class-name": tableRowClassName
      }, {
        default: _withCtx(() => [
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "signTime",
                align: "center",
                label: "日期",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.signTime)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.signTime.slice(0, 10)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                align: "center",
                prop: "code",
                label: "编号",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                prop: "jName",
                align: "center",
                label: "教务",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                prop: "sName",
                align: "center",
                label: "学员姓名",
                "show-overflow-tooltip": "",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_popover, {
                    effect: "light",
                    trigger: "hover",
                    placement: "right",
                    width: "auto"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, "学员姓名: " + _toDisplayString(scope.row.sName), 1),
                      _createElementVNode("div", null, "手机号码: " + _toDisplayString(scope.row.phone), 1),
                      _createElementVNode("div", null, "邮箱地址: " + _toDisplayString(scope.row.email), 1),
                      _createElementVNode("div", null, [
                        _hoisted_22,
                        (scope.row.idCard)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope.row.idCard.slice(0, 6)) + " **** " + _toDisplayString(scope.row.idCard.slice(16, 19)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, "本科院校: " + _toDisplayString(scope.row.college), 1),
                      _createElementVNode("div", null, "本科专业: " + _toDisplayString(scope.row.major), 1),
                      _createElementVNode("div", null, "目标院校: " + _toDisplayString(scope.row.targetCollege), 1),
                      _createElementVNode("div", null, "目标院系: " + _toDisplayString(scope.row.targetAcademy), 1),
                      _createElementVNode("div", null, "目标专业: " + _toDisplayString(scope.row.targetMajor), 1),
                      _createElementVNode("div", null, "负责顾问: " + _toDisplayString(scope.row.gName), 1),
                      _createElementVNode("div", null, [
                        _hoisted_24,
                        (scope.row.signTime)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(scope.row.signTime.slice(0, 10)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    reference: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(scope.row.sName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                prop: "isGroup",
                align: "center",
                label: "是否拉群",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.isGroup)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                        _createVNode(_component_el_tag, { type: "success" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.isGroup), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                        _createVNode(_component_el_tag, { type: "danger" }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                prop: "phone",
                align: "center",
                label: "电话",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                prop: "college",
                align: "center",
                label: "本科学校",
                width: "150"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                prop: "major",
                align: "center",
                label: "本科专业",
                width: "150"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                prop: "targetCollege",
                align: "center",
                label: "目标学校",
                width: "150"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                prop: "targetMajor",
                align: "center",
                label: "目标专业",
                width: "200"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 10,
                prop: "info",
                align: "center",
                label: "调剂进度以及备注",
                width: "350"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 11,
                prop: "charge",
                align: "center",
                label: "收费",
                width: "150"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 12,
                prop: "gName",
                align: "center",
                label: "顾问",
                width: "350"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 13,
                prop: "jName",
                align: "center",
                label: "教务",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 14,
                align: "center",
                prop: "code",
                label: "班号",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 15,
                prop: "sName",
                align: "center",
                label: "学员姓名",
                "show-overflow-tooltip": "",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_popover, {
                    effect: "light",
                    trigger: "hover",
                    placement: "right",
                    width: "auto"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, "学员姓名: " + _toDisplayString(scope.row.sName), 1),
                      _createElementVNode("div", null, "手机号码: " + _toDisplayString(scope.row.phone), 1),
                      _createElementVNode("div", null, "邮箱地址: " + _toDisplayString(scope.row.email), 1),
                      _createElementVNode("div", null, [
                        _hoisted_29,
                        (scope.row.idCard)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(scope.row.idCard.slice(0, 6)) + " **** " + _toDisplayString(scope.row.idCard.slice(16, 19)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, "本科院校: " + _toDisplayString(scope.row.college), 1),
                      _createElementVNode("div", null, "本科专业: " + _toDisplayString(scope.row.major), 1),
                      _createElementVNode("div", null, "目标院校: " + _toDisplayString(scope.row.targetCollege), 1),
                      _createElementVNode("div", null, "目标院系: " + _toDisplayString(scope.row.targetAcademy), 1),
                      _createElementVNode("div", null, "目标专业: " + _toDisplayString(scope.row.targetMajor), 1),
                      _createElementVNode("div", null, "负责顾问: " + _toDisplayString(scope.row.gName), 1),
                      _createElementVNode("div", null, [
                        _hoisted_31,
                        (scope.row.signTime)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(scope.row.signTime.slice(0, 10)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    reference: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(scope.row.sName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 16,
                prop: "targetCollege",
                align: "center",
                label: "目标院校",
                width: "150"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 17,
                prop: "targetAcademy",
                align: "center",
                label: "目标院系",
                width: "200"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 18,
                prop: "targetMajor",
                align: "center",
                label: "目标专业",
                width: "200"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 19,
                prop: "classHour",
                align: "center",
                label: "课时",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 20,
                prop: "info",
                align: "center",
                label: "课程进度",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 21,
                prop: "charge",
                align: "center",
                label: "收费",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 22,
                prop: "gName",
                align: "center",
                label: "销售",
                width: "350"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 23,
                prop: "classType",
                align: "center",
                label: "版型",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 24,
                prop: "postgraduate",
                align: "center",
                label: "研究生",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 25,
                prop: "postgraduateContact",
                align: "center",
                label: "研究生联系方式",
                width: "150"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 26,
                prop: "postgraduateAgreement",
                align: "center",
                label: "研究生协议",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.postgraduateAgreement)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                        _createVNode(_component_el_tag, { type: "success" }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                        _createVNode(_component_el_tag, { type: "danger" }, {
                          default: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 27,
                prop: "isSuccess",
                align: "center",
                label: "是否上岸",
                width: "120"
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 28,
                prop: "studentAgreement",
                align: "center",
                label: "学员协议",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.studentAgreement)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                        _createVNode(_component_el_tag, { type: "success" }, {
                          default: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                        _createVNode(_component_el_tag, { type: "danger" }, {
                          default: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 29,
                prop: "signTime",
                align: "center",
                label: "日期",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.signTime)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(scope.row.signTime.slice(0, 10)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作",
            fixed: "right",
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "warning",
                onClick: ($event: any) => (handleShowEdit(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                title: "是否删除该条学员信息?",
                onConfirm: ($event: any) => (handleDelete(scope.row.id))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(_component_el_pagination, {
        "page-sizes": [100, 200, 300, 400],
        "page-size": _unref(pageSize),
        "current-page": _unref(currentPage),
        background: "",
        layout: "total, prev, pager, next, sizes",
        total: _unref(totalPage),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-size", "current-page", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialogVisible),
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
      title: popStatus.value ? '新增信息' : '编辑信息',
      width: "600px"
    }, {
      default: _withCtx(() => [
        (typeShow.value)
          ? (_openBlock(), _createBlock(_component_el_tabs, {
              key: 0,
              modelValue: activeName2.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeName2).value = $event)),
              type: "card",
              onTabClick: _cache[7] || (_cache[7] = ($event: any) => (handleClickType2(activeName2.value)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "调剂",
                  name: "1"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "复试",
                  name: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (activeName2.value === '1')
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              rules: rules,
              model: _unref(userInfo),
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                (popStatus.value)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "智能识别(调剂)"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(quickCont),
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(quickCont) ? (quickCont).value = $event : quickCont = $event)),
                          type: "textarea",
                          autosize: "",
                          style: {"width":"350px"},
                          placeholder: "可粘贴信息，系统智能识别"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          style: {"width":"80px","margin-left":"10px"},
                          loading: _unref(btnLoading),
                          onClick: handleDistinguish
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "学员姓名",
                  prop: "sName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).sName,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(userInfo).sName) = $event)),
                      placeholder: "请输入姓名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "编号",
                  prop: "code"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).code,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(userInfo).code) = $event)),
                      placeholder: "请输入编号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "电话",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).phone,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(userInfo).phone) = $event)),
                      placeholder: "请输入电话号码"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "本科院校",
                  prop: "college"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).college,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(userInfo).college) = $event)),
                      placeholder: "请输入本科院校"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "本科专业",
                  prop: "major"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).major,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(userInfo).major) = $event)),
                      placeholder: "请输入本科专业"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标院校",
                  prop: "targetCollege"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).targetCollege,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(userInfo).targetCollege) = $event)),
                      filterable: "",
                      placeholder: "请输入目标院校",
                      onChange: handleSelectCollege
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(universityArr).university, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.name
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      style: {"margin-left":"10px"},
                      type: "text",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_46
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标院系",
                  prop: "targetAcademy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).targetAcademy,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(userInfo).targetAcademy) = $event)),
                      placeholder: "请选择目标院系",
                      onChange: handleSelectAcademy
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(academyArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.academyName,
                            value: item.academyName
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标专业",
                  prop: "targetMajor"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).targetMajor,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(userInfo).targetMajor) = $event)),
                      placeholder: "请选择目标专业"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(majorArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.majorName,
                            value: item.majorName
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "教务",
                  prop: "jId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).jId,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(userInfo).jId) = $event)),
                      filterable: "",
                      placeholder: "请选择教务"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fuzerenArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "顾问名称",
                  prop: "gId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).gId,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(userInfo).gId) = $event)),
                      filterable: "",
                      placeholder: "请选择顾问"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(xuejieArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.nickname,
                            value: item.wxid
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      style: {"margin-left":"10px"},
                      type: "text",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_47
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "收费",
                  prop: "charge"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      autosize: "",
                      placeholder: "请输入收费信息",
                      modelValue: _unref(userInfo).charge,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(userInfo).charge) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "是否拉群",
                  prop: "isGroup"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      autosize: "",
                      placeholder: "请输入拉群信息",
                      modelValue: _unref(userInfo).isGroup,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(userInfo).isGroup) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "调剂进度及备注",
                  prop: "info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请输入内容",
                      modelValue: _unref(userInfo).info,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(userInfo).info) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "日期",
                  prop: "signTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(userInfo).signTime,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(userInfo).signTime) = $event)),
                      type: "date",
                      format: "YYYY/MM/DD",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "请选择报名时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_isRef(dialogVisible) //@ts-ignore
 ? dialogVisible.value = false : dialogVisible = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "primary",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (handleInsert(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_49
                      ]),
                      _: 1
                    })), [
                      [
                        _directive_loading,
                        editLoading.value,
                        void 0,
                        {
                          fullscreen: true,
                          lock: true
                        }
                      ]
                    ]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (handleTest()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_50
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true),
        (activeName2.value === '2')
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 2,
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              rules: rules,
              model: _unref(userInfo),
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                (popStatus.value)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "智能识别(复试)"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(quickCont),
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(quickCont) ? (quickCont).value = $event : quickCont = $event)),
                          type: "textarea",
                          autosize: "",
                          style: {"width":"350px"},
                          placeholder: "可粘贴信息，系统智能识别"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          style: {"width":"80px","margin-left":"10px"},
                          loading: _unref(btnLoading),
                          onClick: handleDistinguish
                        }, {
                          default: _withCtx(() => [
                            _hoisted_51
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "学员姓名",
                  prop: "sName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).sName,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(userInfo).sName) = $event)),
                      placeholder: "请输入学员姓名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标院校",
                  prop: "targetCollege"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).targetCollege,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(userInfo).targetCollege) = $event)),
                      filterable: "",
                      placeholder: "请输入目标院校",
                      onChange: handleSelectCollege
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(universityArr).university, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.name
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      style: {"margin-left":"10px"},
                      type: "text",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_52
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标院系",
                  prop: "targetAcademy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).targetAcademy,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(userInfo).targetAcademy) = $event)),
                      placeholder: "请选择目标院系",
                      onChange: handleSelectAcademy
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(academyArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.academyName,
                            value: item.academyName
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标专业",
                  prop: "targetMajor"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).targetMajor,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(userInfo).targetMajor) = $event)),
                      placeholder: "请选择目标专业"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(majorArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.majorName,
                            value: item.majorName
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "是否上岸",
                  prop: "isSuccess"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).isSuccess,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(userInfo).isSuccess) = $event)),
                      placeholder: "请输入上岸情况"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "学员协议",
                  prop: "studentAgreement"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).studentAgreement,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(userInfo).studentAgreement) = $event)),
                      placeholder: "请选择学员协议签署情况"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentAgreementArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "班型",
                  prop: "classType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).classType,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(userInfo).classType) = $event)),
                      placeholder: "请输入班型"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "班号",
                  prop: "code"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).code,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(userInfo).code) = $event)),
                      placeholder: "请输入班号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "课时",
                  prop: "classHour"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).classHour,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(userInfo).classHour) = $event)),
                      placeholder: "请输入课时"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "课程进度",
                  prop: "info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).info,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(userInfo).info) = $event)),
                      placeholder: "请输入课程进度"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "研究生姓名",
                  prop: "postgraduate"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).postgraduate,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(userInfo).postgraduate) = $event)),
                      placeholder: "请输入研究生姓名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "研究生联系方式",
                  prop: "postgraduateContact"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).postgraduateContact,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(userInfo).postgraduateContact) = $event)),
                      placeholder: "请输入研究生联系方式"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "研究生协议",
                  prop: "postgraduateAgreement"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).postgraduateAgreement,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(userInfo).postgraduateAgreement) = $event)),
                      placeholder: "请选择研究生协议签署情况"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postgraduateAgreementArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "收费",
                  prop: "charge"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(userInfo).charge,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(userInfo).charge) = $event)),
                      placeholder: "请输入收费详情"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "销售",
                  prop: "gId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).gId,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(userInfo).gId) = $event)),
                      filterable: "",
                      placeholder: "请选择销售"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(xuejieArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.nickname,
                            value: item.wxid
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      style: {"margin-left":"10px"},
                      type: "text",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "教务",
                  prop: "jId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(userInfo).jId,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(userInfo).jId) = $event)),
                      filterable: "",
                      placeholder: "请选择教务"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fuzerenArr), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "日期",
                  prop: "signTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(userInfo).signTime,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(userInfo).signTime) = $event)),
                      type: "date",
                      format: "YYYY/MM/DD",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "请选择日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_isRef(dialogVisible) //@ts-ignore
 ? dialogVisible.value = false : dialogVisible = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 1
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "primary",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (handleInsert(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_55
                      ]),
                      _: 1
                    })), [
                      [
                        _directive_loading,
                        editLoading.value,
                        void 0,
                        {
                          fullscreen: true,
                          lock: true
                        }
                      ]
                    ]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (handleTest()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_56
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible2.value,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((dialogVisible2).value = $event)),
      title: "学生信息录入模板",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeName2.value,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((activeName2).value = $event)),
          type: "card",
          onTabClick: _cache[49] || (_cache[49] = ($event: any) => (handleClickType2(activeName2.value)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "调剂",
              name: "1"
            }),
            _createVNode(_component_el_tab_pane, {
              label: "复试",
              name: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (activeName2.value === '1')
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: temp,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((temp) = $event)),
              type: "textarea",
              autosize: ""
            }))
          : _createCommentVNode("", true),
        (activeName2.value === '2')
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 1,
              modelValue: temp2,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((temp2) = $event)),
              type: "textarea",
              autosize: ""
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, { type: "text" }, {
          default: _withCtx(() => [
            _hoisted_57
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible3.value,
      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((dialogVisible3).value = $event)),
      title: "学生信息Excel导入",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          style: {"text-align":"center"},
          drag: "",
          accept: ".xlsx",
          action: "https://jsonplaceholder.typicode.com/posts/",
          "http-request": handleChange
        }, {
          default: _withCtx(() => [
            _hoisted_58
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})